import { useIntl } from "react-intl";
import ErrorPage from "../ErrorPage";

/**
 * Access Denied page displayed when a user navigates to a route
 * they do not have permission to view.
 */
function AccessDenied() {
  const intl = useIntl();

  return (
    <ErrorPage
      illustrationKind="Warning"
      statusCode={intl.formatMessage({
        id: "+eVNbW",
        defaultMessage: "403",
        description: "403 access denied code",
      })}
      title={intl.formatMessage({
        id: "f3dr7m",
        defaultMessage: "Access Denied",
        description: "Title for the 403 access denied screen",
      })}
      description={intl.formatMessage({
        id: "T3fexd",
        defaultMessage:
          "You do not have permission to view this page. Contact your administrator if you believe this is an error.",
        description: "Description text on the 403 access denied screen",
      })}
      buttonLabel={intl.formatMessage({
        id: "LLFszj",
        defaultMessage: "Back to Home",
        description:
          "Button label to navigate back to home from access denied page",
      })}
      testId="AccessDenied"
    />
  );
}

export default AccessDenied;
